/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-09-04 14:38:02
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-05-21 15:45:43
 */
import request from '@/utils/request'

export function queryInspection(data) {
  return request({
    url: '/icps/system/sign/intelligent/siloInspection/queryPage', 
    method: 'post',
	data
  })
}
// 查看日志
export function queryResord(data) {
  return request({
    url: '/icps/system/sign/intelligent/siloInspection/queryResord',
    method: 'post',
	data
  })
}